<div
  id="unsupported-device-container"
  [style.display]="isDeviceUnsupported ? 'flex' : 'none'"
>
  <div id="qr-code-container" #qrCodeContainer>
    <app-circle-loader *ngIf="isQRCodeLoading" color="#FFF"></app-circle-loader>
  </div>
  <div id="message">
    <h2>This device is not supported</h2>
    <p>{{ messageDescription }}</p>
  </div>
</div>
